import httpService from "@/utils/services/http_service";

export default {
  /**
   * @author: zhengyongbo
   * date: 2020-02-04
   * 管理员角色列表
   */
  async getRoleList(data = {}) {
    return httpService.post(
      '/api.php?do=admin_member_role_list',
      data
    )
  },

  /**
   * @author: zhengyongbo
   * date: 2020-02-04
   * 管理员权限列表
   */
  async getRightCodeList(data = {}) {
    return httpService.post(
      '/api.php?do=admin_member_rightcode_list',
      data
    )
  },

  /**
   * @author: zhengyongbo
   * date: 2020-02-04
   * 管理员权限列表
   */
  async getCollectLanguageList(data = {}) {
    return httpService.post(
      '/api.php?do=admin_catch_language_list',
      data
    )
  }
}
